import React, { useState, useEffect } from "react";
import BgSuccess from "../../images/bg-success.svg";
import { Button } from "antd";
import _ from "lodash";
import { useLocation, useHistory } from "react-router-dom";

const Step6 = ({ setLoading, loading }) => {
  const history = useHistory();
  const location = useLocation();
  const [statusPayment, setStatusPayment] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    handlePayment();
  }, []);

  const handlePayment = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    setStatusPayment(status === "1");
      setLoading(false);
      setLoaded(true);
      setTimeout(() => {
        sessionStorage.removeItem("bookingInfo");
        const { pathname } = location;
        history.replace(pathname);
      }, 2000);
  };

  return (
    <div className="bg-[#F6F6F6] h-screen">
      <div>
        <img src={BgSuccess} alt="" className="w-full" />
        <div className="w-full mb-4">
          <div className="flex flex-col justify-center gap-4 w-full px-4 items-center">
            {loaded && (
              <>
                {statusPayment ? (
                  <div>
                    <div className="text-[20px] text-[#00AB56] font-bold text-center mb-4">
                      Thanh toán thành công
                    </div>
                    {/* {transaction && (
                      <div className="text-center text-[16px] text-[#27272A]">
                        Chúng tôi vừa gửi cho bạn một email có chứa thông tin
                        đặt vé, xin vui lòng kiểm tra lại email của bạn
                      </div>
                    )} */}
                  </div>
                ) : (
                  <div className="text-[20px] text-[#D72F20] font-bold text-center">
                    Thanh toán thất bại
                  </div>
                )}
              </>
            )}
            <div className="text-center text-[14px] text-[#27272A] mt-4">
              Tham khảo hàng trăm chuyến bay khác trên IPass ngay bây giờ!
            </div>
          </div>
          <div className="w-full mt-4 px-4">
            <div className="flex justify-between mt-4">
              <Button
                onClick={() => {
                  window.location.href = "/";
                }}
                type="primary"
                className="w-[45%] h-[45px] rounded-[10px] text-center mx-auto text-[15px]"
              >
                <span className="font-semibold">Trang chủ</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step6;
